module.exports = __webpack_public_path__ + "assets/filter.5880a362.svg";